<template>
  <div id="AddPhoneCodeView" class="add-phone-code-view">
    <b-row class="pt-3">
      <b-col class="add-phone-code">
        <b-form id="add-phone-code-form" @submit.prevent="save" class="add-form">
          <b-form-row>
            <b-col sm="10">
              <b-form-group label="Page title">
                <b-form-input v-model="code.pageTitle" :disabled="isLoading" required></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col sm="10">
              <b-form-group label="Page description" description="Meta tag page description">
                <b-form-textarea v-model="code.pageDescription" :disabled="isLoading" :rows="2" required></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col sm="10">
              <b-form-group label="Keywords">
                <b-form-input v-model="code.keywords" :disabled="isLoading" required></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col sm="8">
              <b-form-group label="Country name">
                <b-form-input v-model="code.countryName" :disabled="isLoading" required></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group label="Iso-2">
                <b-form-input v-model="code.id" :disabled="isLoading" maxlength="2" required></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col sm="10">
              <b-form-group label="Body title">
                <b-form-input v-model="code.bodyTitle" :disabled="isLoading"></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>

            <b-form-row>
            <b-col sm="10">
              <b-form-group label="Override h1" description="Use this field to create a h1 tag on top of the page">
                <b-form-input v-model="code.overrideh1" :disabled="isLoading"></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col sm="12">
              <b-form-group label="Body description" description="Html content article">
                <b-form-textarea v-model="code.body" :disabled="isLoading" :rows="12" required></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row class="submit">
            <b-col cols="12" sm="12">
              <b-button type="submit" size="lg" variant="primary" :disabled="isLoading">Save</b-button>
            </b-col>
          </b-form-row>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import IcgLeftNav from '@/components/layout/IcgLeftNav'
import Header from '@/components/layout/Header'
import PhoneCodesTabs from '@/components/PhoneCodesTabs'
export default {
  name: 'PhoneCodesAdd',
  components: {
    Header,
    PhoneCodesTabs,
    IcgLeftNav
  },
  created () {
    this.startNewPhoneCode().then(() => {
      let newCode = this.$store.state.icg.newPhoneCode
      this.code = Object.assign({}, newCode)
    })
  },
  computed: {
    ...mapGetters({
      isLoading: 'loader/isLoading'
    })
  },
  methods: {
    ...mapActions({
      'savePhoneCode': 'icg/savePhoneCode',
      'startNewPhoneCode': 'icg/startNewPhoneCode'
    }),
    save () {
      var locale = 'en'
      this.savePhoneCode(locale).then(() => {
        this.$toastr.s('Phone code saved')
        this.startNewPhoneCode().then(() => {
          let newCode = this.$store.state.icg.newPhoneCode
          this.code = Object.assign({}, newCode)
          this.$router.push({name: 'phoneCodes'})
        })
      }).catch((error) => {
        this.$toastr.e(error)
      })
    }
  },
  watch: {
    code: {
      handler (newValue) {
        this.$store.dispatch('icg/setPhoneCode', newValue)
      },
      deep: true
    }
  },
  data () {
    return {
      code: {}
    }
  }
}
</script>

<style lang="scss" scoped>

.has-error {
  color: #ff0000;
  input {
    border-color: #ff0000;
  }
}

.add-form {
  max-width: 750px;
}
.submit{
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/icg/PhoneCodesAdd.vue